class SettingsModel {
  releaseThresholdDay;
  releaseThresholdNight;
  autoRelease;

  constructor(data) {
    this.populate(data || {});
  }

  populate(data) {
    this.releaseThresholdDay = data.releaseThresholdDay || null;
    this.releaseThresholdNight = data.releaseThresholdNight || null;
    this.autoRelease = data.autoRelease || null;
  }
}

export { SettingsModel };
